import { AbstractNotificationsService } from './AbstractNotificationsService';
import { INotificationsService } from './notificationsServiceTypes';

export class NotificationsServiceStub
	extends AbstractNotificationsService
	implements INotificationsService
{
	constructor() {
		super();

		(window as any).testNotificationsQueue = (
			count: number = 6,
			intervalMs: number = 220,
		) => {
			let index = 0;
			const timer = setInterval(() => {
				index += 1;
				if (index % 2 === 0) {
					this.showCounter('Золотая монета', index, 'apple');
				} else if (index % 3 === 0) {
					this.showError(`Ошибка #${index}`);
				} else {
					this.showSuccess(`Тестовое уведомление #${index}`);
				}

				if (index >= count) {
					clearInterval(timer);
				}
			}, intervalMs);

			return timer;
		};
	}
}
